const Documents = () => {
  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Документы</h2>
      <ul className="space-y-3">
        <li><a href="/documents/egrip.pdf" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline flex items-center gap-2">📄 Выписка из ЕГРИП</a></li>
        <li><a href="/documents/license.pdf" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline flex items-center gap-2">📜 Лицензия на образовательную деятельность</a></li>
      </ul>
    </div>
  );
};

export default Documents;
